;(() => {
    const stickies = document.querySelectorAll('.js-sticky-on-scroll')
    const offsetBottom = 60

    stickies.forEach(el => {
        const top = el.offsetTop
        const threshold = el.dataset.stickyThreshold

        const scrollHandle = () => {
            if (window.innerWidth <= threshold) {
                el.style.position = 'static'
                return
            }

            const height = el.offsetHeight
            if (height < window.innerHeight) {
                el.style.position = 'sticky'
                el.style.top = '120px'
                return
            }

            const fullHeight = height + top + offsetBottom
            const windowScroll = window.scrollY
            const windowHeight = window.innerHeight

            if (window.innerWidth <= threshold) {
                el.style.position = 'static'
                return
            }

            if (windowScroll > fullHeight - windowHeight) {
                el.style.position = 'sticky'
                el.style.top = -(height - windowHeight + 50) + 'px'
            } else {
                el.style.position = 'static'
            }
        }

        scrollHandle()

        let resizeTimer = null
        let orientationTimer = null

        window.addEventListener('scroll', scrollHandle, { passive: true })

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(scrollHandle, 100)
        })

        window.addEventListener('orientationchange', () => {
            clearTimeout(orientationTimer)
            orientationTimer = setTimeout(scrollHandle, 100)
        })
    })
})()
